import React from 'react';
import { Modal, Button } from 'react-bootstrap';
const DeleteConfirmationModal = ({ show, handleClose, handleDelete, address_id }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header style={{ backgroundColor: "#C99700" ,display:'flex', justifyContent:'end'}} closeButton>
        <Modal.Title style={{ color: "#fff" }}>Delete Address</Modal.Title>
        <div className='flex-grow-1'></div>
      </Modal.Header>
      <Modal.Body>Are you sure you want to delete this address?</Modal.Body>
      <Modal.Footer className='d-flex justify-content-center' >
        <div className='d-flex gap-4 '>
          <Button style={{ backgroundColor: "#C99700", border: "none" }} onClick={handleDelete}>
            Delete
          </Button>
          <Button className='ms-2' style={{ backgroundColor: "#C99700", border: "none" }} onClick={handleClose}>
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;